import Papa, { ParseResult } from 'papaparse';
import { createEmployee, FetchAlljobLocation, getEmployees, updateBankDetails } from '../core/data/redux/employee/employeeAction';
import { AppDispatch } from '../core/data/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { fetchAllDepartments } from '../core/data/redux/department/departmentAction';
import { fetchAllDesignations } from '../core/data/redux/designation/designationAction';
import { fetchAllBranch } from '../core/data/redux/branch/branch.Action';
import { fetchAllLeaveTypes } from '../core/data/redux/attendance/leaveTypes/LeaveTypeActions';
import { fetchingexperience } from '../core/data/redux/experience/experience.Action';

export const useEmployeeCSVImport = (setTableKey: React.Dispatch<React.SetStateAction<number>>) => {
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: any) => state.auth);
    const { departments } = useSelector((state: any) => state.department);
    const { designations } = useSelector((state: any) => state.designation);
    const { roles } = useSelector((state: any) => state.role);
    const { employees } = useSelector((state: any) => state.employee);
    const { branch } = useSelector((state: any) => state.branch);
    const [joblocation, setjoblocation] = useState<any>([]);
    const [experience, setexperience] = useState([]);

    useEffect(() => {
        dispatch(fetchAllDepartments());
        dispatch(fetchAllDesignations());
        dispatch(fetchAllBranch());
        dispatch(FetchAlljobLocation()).then((res) => {
            setjoblocation(res.payload.data);
        });
        dispatch(fetchAllLeaveTypes());
        dispatch(fetchingexperience()).then((res) => {
            setexperience(res.payload.data);
        });
        dispatch(getEmployees());
    }, []);

    

   

    const handleCSVImport = (file: File) => {
        
        message.loading({ content: 'Importing employees...', key: 'import' });
        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: async function (results: ParseResult<any>) {
                const records = results.data as any[];
                let validCount = 0;
                let invalidCount = 0;

                for (let row of records) {
                    const validationErrors = [];
                    // --- Convert Name Fields to IDs (with null-safe lookups) ---
                    const designationObj = designations?.find(
                        (d: any) => d?.DesignationName?.trim().toLowerCase() === (row.Designation || '').trim().toLowerCase()
                    );
                   

                    const departmentObj = departments?.find(
                        (d: any) => d?.Name?.toLowerCase() === row.Department?.toLowerCase()
                    );
                    

                    const roleObj = roles?.find(
                        (r: any) => r?.RoleName?.trim().toLowerCase() === (row.EmployeeRole || '').trim().toLowerCase()
                    );


                    const branchObj = branch?.find(
                        (b: any) => b?.Branch_Name?.trim().toLowerCase() === (row.Branch || '').trim().toLowerCase()
                    );

                    const normalize = (str: string) =>
                        (str || '').replace(/\s+/g, ' ').trim().toLowerCase();

                    const managerObj = employees?.find(
                        (e: any) =>
                            normalize(`${e?.FirstName || ''} ${e?.LastName || ''}`) ===
                            normalize(row.ReportingManager)
                    );


                    const hodObj = employees?.find(
                        (e: any) =>
                            normalize(`${e?.FirstName || ''} ${e?.LastName || ''}`) ===
                            normalize(row.hod) 
                    );
                    row.hod_id = hodObj?.EmployeeID || null;

                    const genderIdMap: Record<string, number> = {
                        Male: 1,
                        Female: 2,
                        Other: 3,
                    };
                    
                    const genderId = row.Gender  ? genderIdMap[row.Gender] || null : null;
                    // --- Replace names with IDs if found ---
                    row.designation = designationObj?.DesignationId || null;
                    row.department = departmentObj?.Id || null;
                    row.EmployeeRole = roleObj?.RoleId || null;
                    row.branch = branchObj?.Id || null;
                    row.ReportingManager = managerObj?.EmployeeID || null;
                    row.gender = genderId;
                    // --- Validation checks ---
                    if (!row.FirstName || !row.LastName) validationErrors.push("Missing name.");
                    if (!row.Email || !/^\S+@\S+\.\S+$/.test(row.Email)) validationErrors.push("Invalid email.");
                    if (!row.Password) validationErrors.push("Password required.");
                    if (isNaN(Date.parse(row.DateOfBirth))) validationErrors.push("Invalid DOB.");
                    if (!row.Gender) validationErrors.push("Invalid gender (use Male/Female/Other).");
                    if (!row.Designation) validationErrors.push("Invalid designation name.");
                    if (!row.Department) validationErrors.push("Invalid department name.");
                    if (isNaN(Date.parse(row.JoiningDate))) validationErrors.push("Invalid joining date.");
                    if (!/^\d{10}$/.test(row.PhoneNumber)) validationErrors.push("Invalid phone number.");
                    // if (!row.ReportingManager) validationErrors.push("Invalid reporting manager name.");
                    if (!row.Company) validationErrors.push("Company required.");
                    if (!row.EmployeeRole) validationErrors.push("Invalid role name.");
                    if (
                        !['Full-time', 'Part-time', 'Contract', 'Freelance', 'Internship'].includes(row.EmploymentType)
                    )
                        validationErrors.push("Invalid employment type.");
                    if (!['Remote', 'Client-side', 'Work from Office'].includes(row.WorkPreference))
                        validationErrors.push("Invalid work preference.");
                    if (!['Active', 'Inactive'].includes(row.Employee_status))
                        validationErrors.push("Invalid status.");
                    if (![0, 1].includes(+row.PfEnable))
                        validationErrors.push("PF Enable must be 0 or 1.");
                    if (!row.Branch) validationErrors.push("Invalid branch name.");
                    if (!row.Job_location) validationErrors.push("Job location required.");
                    if (!row.BankAccountForPayroll || row.BankAccountForPayroll.length < 6)
                        validationErrors.push("Invalid Account Number");
                    if (!row.BankIfscForPayroll || row.BankIfscForPayroll.length < 5)
                        validationErrors.push("Invalid IFSC");
                    if (!row.BankNameForPayroll || row.BankNameForPayroll.trim() === '')
                        validationErrors.push("Bank name is required");
                    if (!row.BankBranchAddress || row.BankBranchAddress.trim() === '')
                        validationErrors.push("Branch address is required");

                    if (validationErrors.length) {
                        message.warning(`Skipping ${row.email || 'entry'}: ${validationErrors.join(', ')}`);
                        invalidCount++;
                        continue;
                    }

                    const employeeData = mapCSVRowToEmployee(row);
                    try {
                        const result = await dispatch(createEmployee(employeeData));
                        if (createEmployee.rejected.match(result)) {
                            const errorMsg =
                                typeof result.payload === 'string'
                                    ? result.payload
                                    : 'Failed to import employee';
                            message.error(errorMsg);
                            invalidCount++;
                        } else {
                            validCount++;
                            const employeeId = result.payload?.data.EmployeeId;
                            if (employeeId) {
                                const bankPayload = {
                                    BankAccountForPayroll: row.BankAccountForPayroll || '',
                                    BankNameForPayroll: row.BankNameForPayroll || '',
                                    BankIfscForPayroll: row.BankIfscForPayroll || '',
                                    BankBranchAddress: row.BankBranchAddress || '',
                                };
                                const hasBankDetails = Object.values(bankPayload).every((v) => !!v.trim());
                                if (hasBankDetails) {
                                    const bankResult = await dispatch(
                                        updateBankDetails({ employeeId, bankDetails: bankPayload })
                                    );
                                    if (updateBankDetails.rejected.match(bankResult)) {
                                        message.warning(
                                            `Employee created but failed to update bank details for ${row.email}`
                                        );
                                    }
                                }
                            }
                        }
                    } catch (error) {
                        message.error('Unexpected error while creating employee.');
                        invalidCount++;
                    }
                }


                await dispatch(getEmployees());
                setTableKey((prev) => prev + 1);

                message.success({
                    content: `Imported: ${validCount}, Skipped: ${invalidCount}`,
                    key: 'import',
                    duration: 4,
                });
            },
        });
    };

    const mapCSVRowToEmployee = (row: any) => {
        return {
            Name: `${row.FirstName} ${row.LastName}`,
            Email: row.Email,
            FirstName: row.FirstName,
            LastName: row.LastName,
            UserId: 0,
            password: row.Password,
            DateOfBirth: dayjs(row.DateOfBirth).format('YYYY-MM-DD'),
            GenderId: row.gender,
            DesignationId: row.designation,
            DepartmentId: row.department,
            DateOfJoining: dayjs(row.JoiningDate).format('YYYY-MM-DD'),
            mobile: row.PhoneNumber,
            ModifiedBy: 1,
            Description: row.About,
            SupervisorId: row.ReportingManager || 0,
            profilePicture: null,
            Company: row.Company,
            RoleId: row.EmployeeRole,
            employmentType: row.EmploymentType,
            workPreference: row.WorkPreference,
            employee_status: row.Employee_status,
            pfEnable: row.PfEnable,
            branch: row.branch,
            job_location: row.Job_location,
            BankAccountForPayroll: row.BankAccountForPayroll || '',
            BankNameForPayroll: row.BankNameForPayroll || '',
            BankIfscForPayroll: row.BankIfscForPayroll || '',
            BankBranchAddress: row.BankBranchAddress || '',
            maxUser: user?.total_user,
            hod_id: row.hod_id || null,
        };
    };

    return {
        handleCSVImport
    };
};
